import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as appReportService from "source/models/services/appReportService";
import { handleApiError } from "../storeEffects";
import { AppReportAction, appReportFailure, appReportSuccess } from "./storeAppReport";

export type AppReportThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, AppReportAction>

export const getAppReportPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return appReportService.getAppReportPage()
        .then(
            appReportPage => {
                dispatch(appReportSuccess(appReportPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(appReportFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};